import React, { useState } from 'react'
import { arrayOf, object } from 'prop-types'
import MajorListItem from 'components/atoms/MajorListItem'
import ActionTypeProp from 'utils/prop_types/ActionTypeProp'

const MajorList = ({ list, type }) => {
  const [showAllMajors, setShowAllMajors] = useState(false)

  const toggleShowAll = () => setShowAllMajors(!showAllMajors)

  const majors = !showAllMajors ?
    list.map((major, index) => ({ ...major, hideOnDesktop: index > 5 })) :
    list

  return (
    <div className="major-list">
      <div className="major-list__flex">
        {
          majors.map((major, idx) => (
            <MajorListItem major={major} key={`majors-${idx}`} type={type} />
          ))
        }
      </div>
      {
        list.length > 6 &&
        <a
          href="#"
          className="major-list__show-more"
          onClick={(e) => {
            e.preventDefault()
            toggleShowAll()
          }}
        >
          {showAllMajors ? 'Sembunyikan' : 'Lihat Selengkapnya'}
        </a>
      }
      <style jsx>
        {`
          .major-list {
            &__flex {
              display: flex;
              justify-content: flex-start;
              flex-wrap: nowrap;
              overflow: scroll;
              margin-left: -6px;
              margin-right: -8px;
              scroll-snap-type: x mandatory;
              @media screen and (min-width: 768px) {
                flex-wrap: wrap;
                overflow: unset;
              }
            }
    
            &__show-more {
              display: none;
              font-size: 16px;
              font-weight: 700;
              color: #0fc3c4;
              margin-top: 0.5rem;
              &:focus, &:hover {
                text-decoration: none;
                outline: none;
              }
              @media screen and (min-width: 768px) {
                display: block;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

MajorList.propTypes = {
  list: arrayOf(object),
  type: ActionTypeProp,
}

export default MajorList
